module.exports = __webpack_public_path__ + "static/media/217-Abspann_ID_5.b467a265.mp3";